/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AttendanceEntryRequest } from './AttendanceEntryRequest';
import {
    AttendanceEntryRequestFromJSON,
    AttendanceEntryRequestFromJSONTyped,
    AttendanceEntryRequestToJSON,
    AttendanceEntryRequestToJSONTyped,
} from './AttendanceEntryRequest';

/**
 * 
 * @export
 * @interface PlanWeeklySeriesRequest
 */
export interface PlanWeeklySeriesRequest {
    /**
     * 
     * @type {Date}
     * @memberof PlanWeeklySeriesRequest
     */
    dateFrom: Date;
    /**
     * 
     * @type {Date}
     * @memberof PlanWeeklySeriesRequest
     */
    dateTo: Date;
    /**
     * 
     * @type {string}
     * @memberof PlanWeeklySeriesRequest
     */
    originTimeZoneId: string;
    /**
     * 
     * @type {Array<AttendanceEntryRequest>}
     * @memberof PlanWeeklySeriesRequest
     */
    entries: Array<AttendanceEntryRequest>;
}

/**
 * Check if a given object implements the PlanWeeklySeriesRequest interface.
 */
export function instanceOfPlanWeeklySeriesRequest(value: object): value is PlanWeeklySeriesRequest {
    if (!('dateFrom' in value) || value['dateFrom'] === undefined) return false;
    if (!('dateTo' in value) || value['dateTo'] === undefined) return false;
    if (!('originTimeZoneId' in value) || value['originTimeZoneId'] === undefined) return false;
    if (!('entries' in value) || value['entries'] === undefined) return false;
    return true;
}

export function PlanWeeklySeriesRequestFromJSON(json: any): PlanWeeklySeriesRequest {
    return PlanWeeklySeriesRequestFromJSONTyped(json, false);
}

export function PlanWeeklySeriesRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlanWeeklySeriesRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'dateFrom': (new Date(json['dateFrom'])),
        'dateTo': (new Date(json['dateTo'])),
        'originTimeZoneId': json['originTimeZoneId'],
        'entries': ((json['entries'] as Array<any>).map(AttendanceEntryRequestFromJSON)),
    };
}

export function PlanWeeklySeriesRequestToJSON(json: any): PlanWeeklySeriesRequest {
    return PlanWeeklySeriesRequestToJSONTyped(json, false);
}

export function PlanWeeklySeriesRequestToJSONTyped(value?: PlanWeeklySeriesRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'dateFrom': `${value['dateFrom'].getFullYear()}-${String(value['dateFrom'].getMonth()+1).padStart(2,'0')}-${String(value['dateFrom'].getDate()).padStart(2,'0')}`,
        'dateTo': `${value['dateTo'].getFullYear()}-${String(value['dateTo'].getMonth()+1).padStart(2,'0')}-${String(value['dateTo'].getDate()).padStart(2,'0')}`,
        'originTimeZoneId': value['originTimeZoneId'],
        'entries': ((value['entries'] as Array<any>).map(AttendanceEntryRequestToJSON)),
    };
}

